import CustomTable from "./CustomTable";
import { CustomTableProps } from "./ITable";

const renderTable = (props: CustomTableProps) => {
  return <CustomTable {...props} />;
};

export default renderTable;
